//
//
//
//
//

export default {
    props: {
      top: {
        type: Number,
        default: 500
      }
    },
    data (){
        return {

        }
    },
    beforeDestroy () {
        $(window).off();
    },
    mounted: function () {
        this.init(this.top);
    },
    methods: {
        init(t){
          let $dom = $('.backtop');
          $(window).on('scroll', function(){
            var top = $(this).scrollTop();
            if(top > t){
              $dom.addClass('scroll-show').removeClass('scroll-hide');
            }else{
              $dom.addClass('scroll-hide').removeClass('scroll-show');
            }
          });
        },
        backTop(){
            $(window).scrollTop(0);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/backtop/backtop.vue